import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AppRouteTypes } from 'enums';
import * as auth from 'util/auth';

class ProtectedRoute extends React.Component {
  getRouteVariables = (type, isAuthenticated) => {
    const { location } = this.props;

    switch (type) {
      case AppRouteTypes.LOGIN_ROUTE:
        return [!isAuthenticated, '/suite/dashboard'];

      case AppRouteTypes.PRIVATE_ROUTE:
        return this.getVariablesForPrivateRoutes(isAuthenticated, location);

      case AppRouteTypes.ERROR_ROUTE:
        return [isAuthenticated, '/login'];

      default:
        return [isAuthenticated, '/login'];
    }
  };

  getVariablesForPrivateRoutes = (isAuthenticated, location) => {
    if (!isAuthenticated) {
      try {
        const redirectPath = `${location.pathname}${location.search}`;
        document.cookie = `postLoginRedirect=${encodeURIComponent(redirectPath)}; path=/; SameSite=Lax`;
      } catch (error) {
        console.warn('Failed to write redirect cookie', error);
      }
    }

    return [
      isAuthenticated,
      {
        pathname: '/login'
      }
    ];
  };

  render() {
    const { component: Component, type, ...rest } = this.props;
    const isAuthenticated = auth.isLoggedIn();

    const [shouldRender, redirectTo] = this.getRouteVariables(type, isAuthenticated);

    return (
      <Route
        {...rest}
        render={props => (shouldRender ? <Component {...rest} {...props} /> : <Redirect to={redirectTo} />)}
      />
    );
  }
}

ProtectedRoute.propTypes = {
  type: PropTypes.string.isRequired
};

export default withRouter(ProtectedRoute);
